import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step3 } from '../../../../shared/models/component-messages/simp_at/step3';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { TypeCPVClassFNSSimple } from '../models/TypeCPVClassFNSSimple';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'TypeCPVClass';
  @Input() parentForm: FormGroup;
  @Input() typeCPVClass: TypeCPVClassFNSSimple;
  @Input() disabled: boolean;
  public step3 = new Step3();

  public typeCpv = PreferenceType.CODES_CPV;

  constructor() {}

  public ngOnInit() {}

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    this.parentForm.get(this.getUid() + '_SepAtt_classPrincipale')?.setValue(preference?.content?.values[0]?.code);
    this.parentForm.get(this.getUid() + '_SepAtt_classPrincipale')?.markAsTouched();
  }
}
